import { Box } from "@mui/material";
import { FileTypeIcon } from "components/Document/shared";
import { useState } from "react";

type Props = {
  thumbnailUrl?: string;
  fileExtension: string | null | undefined;
};

export function ScoutFileThumbnailContent({ thumbnailUrl, fileExtension }: Props) {
  const [imageLoadFailed, setImageLoadFailed] = useState(false);
  const showThumbnail = thumbnailUrl !== undefined && !imageLoadFailed;

  if (showThumbnail) {
    return (
      <Box
        component="img"
        src={thumbnailUrl}
        alt=""
        onError={() => setImageLoadFailed(true)}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <FileTypeIcon ext={fileExtension} sx={{ fontSize: 32 }} />
    </Box>
  );
}
